// extracted by mini-css-extract-plugin
export default {"block-tools":"BlockTools_block-tools__YMkR0"};